import React, { useState, useEffect } from 'react';
import { FiMail, FiPhone, FiMapPin, FiGithub, FiLinkedin, FiSend } from 'react-icons/fi';
import './Contact.css';
import API_URL from '../config';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${API_URL}/profile/info`);
        const data = await res.json();
        if (data.success) setProfile(data.data);
      } catch (error) {
        console.error('Failed to fetch profile');
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch(`${API_URL}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await response.json();

      if (data.success) {
        setStatus({ type: 'success', message: data.message });
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatus({ type: 'error', message: data.message });
      }
    } catch (error) {
      setStatus({ type: 'error', message: 'Failed to send message' });
    }
    setLoading(false);
  };

  const email = profile?.email || 'manishmandal23232@gmail.com';
  const phone = profile?.phone || '+977 9705437508';
  const location = profile?.location || 'Hetauda, Nepal';
  const github = profile?.github || 'https://github.com/manishmandal55';
  const linkedin = profile?.linkedin || 'https://linkedin.com/in/manishmandal55';

  return (
    <section className="contact section">
      <div className="container">
        <div className="section-title"><h2>Contact</h2></div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Let's Connect</h3>
            <p>Looking for backend development work. Let's build something together!</p>

            <div className="info-list">
              <div className="info-item">
                <span className="info-icon"><FiMail /></span>
                <div className="info-content">
                  <span className="info-label">Email</span>
                  <a href={`mailto:${email}`}>{email}</a>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon"><FiPhone /></span>
                <div className="info-content">
                  <span className="info-label">Phone</span>
                  <a href={`tel:${phone.replace(/\s/g, '')}`}>{phone}</a>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon"><FiMapPin /></span>
                <div className="info-content">
                  <span className="info-label">Location</span>
                  <span>{location}</span>
                </div>
              </div>
            </div>

            <div className="social-links">
              <h4>Follow Me</h4>
              <div className="social-icons">
                <a href={github} target="_blank" rel="noopener noreferrer" className="social-link"><FiGithub /></a>
                <a href={linkedin} target="_blank" rel="noopener noreferrer" className="social-link"><FiLinkedin /></a>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Send Message</h3>
            
            {status.message && <div className={`form-status ${status.type}`}>{status.message}</div>}

            <div className="form-group">
              <label>Name</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="your@email.com" required />
            </div>

            <div className="form-group">
              <label>Subject</label>
              <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="Subject" required />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea name="message" rows="5" value={formData.message} onChange={handleChange} placeholder="Your message..." required></textarea>
            </div>

            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Sending...' : 'Send'} <FiSend />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
